import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const fallbackLanguage = "fr";
const availableLanguages = ["fr"];

i18n
  .use(HttpApi) // load translations using http (default public/assets/locals/en/translations)
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    backend: {
      allowMultiLoading: false,
      crossDomain: false,
    },
    react: {
      useSuspense: false,
    },
    supportedLngs: availableLanguages,
    fallbackLng: fallbackLanguage,
    debug: false,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
